import { Injectable } from '@angular/core';
import { DatabaseServiceProvider } from '../database-service/database-service';

@Injectable()
export class ModifiersProvider {
  modifierData: any;

  constructor(private afService: DatabaseServiceProvider) {
  }

  getModifiers() {
    var promise = new Promise((resolve, reject) => {
      this.afService.getItemList('modifiers', ref => ref
        .where('locationId', 'array-contains', localStorage.getItem('selectedCity')))
        .map((data) => (data as any)
          .sort((n1, n2) => n1.sort - n2.sort))
        .subscribe((modifiersData) => {
          this.modifierData = modifiersData
          resolve(modifiersData)
        }, err => { reject(err); });
    });
    return promise;
  }

  checkItemHasModifiers(catId, itemId) {
    var promise = new Promise((resolve, reject) => {
      this.getModifiers()
        .then((modifiersData) => {
          modifiersData = (modifiersData as any).filter(m => m.categoryId.includes(catId) || m.itemId.includes(itemId))
          modifiersData = (modifiersData as any).filter(m => m.enableModifier);
          if (modifiersData && (modifiersData as any).length == 0) {
            resolve(false); //no modifers
          } else { 
            resolve(true);
          }
          
        }, err => { reject(false); });

    });
    return promise;
  }


}



// WEBPACK FOOTER //
// ./src/providers/modifiers/modifiers.ts